// version 1.3.0 2025-05-23
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import * as moment_ from 'axis-common-lib/lib-moment/moment.min';

@Injectable({
  providedIn: 'root',
})
export class DateTimeService {
  /* environment */

  moment = moment_.default;

  /* properties */

  constructor(@Inject(DOCUMENT) private document: any) {}

  /* methods */

  addDays(days: string, date?: any): Date {
    // const locale = this.getLocale();
    const dateFormat = this.getCountryDateFormat();
    // day: 'numeric' or '2-digit'
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    if (date === undefined) {
      date = new Date();
    }
    date.setDate(date.getDate() + parseInt(days));
    if (isNaN(date.getTime())) {
      date = new Date();
    }
    // return date.toLocaleDateString(locale, options);
    return this.moment(date).format(dateFormat);
  }

  addDaysToDate(days: string, date?: any): Date {
    // const locale = this.getLocale();
    const dateFormat = this.getCountryDateFormat();
    if (days === '' || days == null) {
      return;
    } // for forms
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    if (date === undefined) {
      date = new Date();
    }
    date.setDate(date.getDate() + parseInt(days));
    if (isNaN(date.getTime())) {
      date = new Date();
    }
    // return date.toLocaleDateString(locale, options);
    return this.moment(date).format(dateFormat);
  }

  addTime(hours: string, date?: Date): Date {
    if (hours === '' || hours == null) {
      hours = '0';
    }
    if (date === undefined) {
      date = new Date();
    }
    date.setHours(date.getHours() + parseInt(hours));
    return date;
  }

  addTimeToDate(time: string, date?: Date): Date {
    // if (time === '' || time == null) { time = '12:00'; }
    if (time === '' || time == null) {
      return;
    } // for forms
    if (date === undefined) {
      date = new Date();
    }
    const [hours, minutes] = time.split(':');
    // date.toLocaleTimeString([], { hourCycle: 'h23', hour: '2-digit', minute: '2-digit' });
    date.setHours(Number(hours));
    date.setMinutes(Number(minutes));
    return date;
  }

  getCountryDateFormat(): string {
    return (
      this.document.documentElement.getAttribute('data-date-format') ||
      'MMM dd, YYYY'
    );
  }

  getDst(days: string): boolean {
    const date = this.addDays(days);
    // return this.moment(date).isDST();
    return false;
  }

  // getLastMonths(number, format='MMMM', order?): any {
  // months.push(this.moment().subtract(index, 'months').format(format));
  getLastMonths(number, format: any = ['en-US', 'long'], order?): any {
    let month;
    let monthName;
    const months = [];
    for (let index = 1; index <= number; index++) {
      // inconsistent with getLastYears
      month = this.moment().subtract(index, 'months');
      monthName = Intl.DateTimeFormat(format[0], { month: format[1] }).format(
        month,
      );
      months.push(monthName);
    }
    if (order) {
      months.reverse();
    }
    return months;
  }

  getLastYears(number, format = 'YYYY', order?): any {
    let year;
    const years = [];
    for (let index = 0; index <= number; index++) {
      // inconsistent with getLastMonths
      year = new Date().getFullYear() - index;
      years.push(year);
    }
    if (order) {
      years.reverse();
    }
    return years;
  }

  getLocale(): string {
    return this.document.documentElement.getAttribute('data-locale') || 'en-US';
  }

  getMonth(format: any = ['en-US', 'long']): string {
    const month = new Date();
    const monthName = Intl.DateTimeFormat(format[0], {
      month: format[1],
    }).format(month);
    return monthName;
  }

  getTime(): string {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    return hours + ':' + minutes;
  }
}
